import { ligainicial } from "./rutainicial.js";
import { pagesipdus } from "./rutainicial";

const ligabase = ligainicial + "2026/Lic/C";
const ligasipdus = pagesipdus + "2026/Lic/C";
const ligasipdusInv = pagesipdus + "2026/Inv/";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 044
        'numConvocatoria' : 'Convocatoria No. 044/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N151-2026.',
        'vigencia' : '14 al 28 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de casetas y mantenimiento del estacionamiento del Estadio Hidalgo.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }44/N151/N151.rar`,
        'start' : '2026-09-14',
        'end' : '2026-09-28',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N150-2026.',
        'vigencia' : '14 al 28 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación y adecuación de áreas de atención a la ciudadanía zona sur, Pachuca de Soto, Hidalgo.; de Cobertura Estatal',
        'urlAnexos' : `${ ligasipdus }44/N150/N150.rar`,
        'start' : '2026-09-14',
        'end' : '2026-09-28',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N149-2026.',
        'vigencia' : '14 al 28 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Mantenimiento del pisal Byron Gálvez.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }44/N149/N149.rar`,
        'start' : '2026-09-14',
        'end' : '2026-09-28',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 043
        'numConvocatoria' : 'Convocatoria No. 043/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N148-2026.',
        'vigencia' : '10 al 24 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Ampliación del CAPASITS Pachuca.; ubicada en la localidad de , Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }43/N148/N148.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N147-2026.',
        'vigencia' : '10 al 24 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Ampliación y rehabilitación del CAIA Tulancingo; ubicada en la localidad de Tulancingo, Municipio de Tulancingo de Bravo, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }43/N147/N147.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N146-2026.',
        'vigencia' : '10 al 24 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de acceso a la Av. Benito Juárez, localidad San Juan Tilcuautla, en el municipio de San Agustín Tlaxiaca.; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }43/N146/N146.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N145-2026.',
        'vigencia' : '10 al 24 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Encauzamiento y saneamiento del río Chinguiñoso, en el municipio de Huejutla de Reyes.; ubicada en la localidad y Municipio de Huejutla de Reyes, Estado de Hidalgo (Segundo procedimiento)',
        'urlAnexos' : `${ ligasipdus }43/N145/N145.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N144-2026.',
        'vigencia' : '10 al 24 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de colector pluvial tierra y libertad, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }43/N144/N144.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N143-2026.',
        'vigencia' : '10 al 24 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Terminación de pavimentación de concreto hidráulico en calle 24 de octubre, San Antonio el Desmonte, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }43/N143/N143.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-24',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 042
        'numConvocatoria' : 'Convocatoria No. 042/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N142-2026.',
        'vigencia' : '10 al 17 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción del encauzamiento Río de las Avenidas (muro izquierdo y plantilla), tramo: Carr. antigua La Paz - avenida Moreda.; ubicada en la localidad de La Noria, Municipio de Mineral de la Reforma, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }42/N142/N142.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-17',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N141-2026.',
        'vigencia' : '10 al 17 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción del encauzamiento Río de las Avenidas (muro izquierdo y derecho), tramo: carr. antigua La Paz - avenida Moreda - fraccionamiento los Tuzos.; ubicada en la localidad de Los Tuzos, Municipio de Mineral de la Reforma, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }42/N141/N141.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-17',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N140-2026.',
        'vigencia' : '10 al 17 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción del paso superior vehicular sobre la C.F. México - Pachuca Km 70+220.; ubicada en la localidad y Municipio de Zapotlán de Juárez, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }42/N140/N140.rar`,
        'start' : '2026-09-10',
        'end' : '2026-09-17',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 041
        'numConvocatoria' : 'Convocatoria No. 041/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N139-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación asfáltica en Av. Hombres Ilustres barrio Mexiquito, en el municipio de San Agustín Tlaxiaca.; ubicada en la localidad y Municipio de San Agustín Tlaxiaca, Estado de Hidalgo (segundo procedimiento).',
        'urlAnexos' : `${ ligasipdus }41/N139/N139.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N138-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de Boulevard E.C. Tolcayuca - Villa de Tezontepec, tramo Arco Norte - polo de desarrollo; ubicada en Varias localidades, de Cobertura Estatal.',
        'urlAnexos' : `${ ligasipdus }41/N138/N138.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },

    {
        // CONVOCATORIA NUM# 040
        'numConvocatoria' : 'Convocatoria No. 040/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N137-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción Edificio 4, Complejo Hidalgo Honesto; ubicada en la localidad de San Juan Tilcuautla, Municipio de San Agustín Tlaxiaca, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N137/N137.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N136-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de áreas comerciales en Sector Primario; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N136/N136.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N135-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de cancha San Francisco, en el municipio de Mineral del Monte.; ubicada en la localidad y Municipio de Mineral del Monte, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N135/N135.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N134-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de la C.E. Cuautepec - Tulancingo (tercera etapa), en el municipio de Cuautepec de Hinojosa.; ubicada en la localidad de Cuautepec, Municipio de Cuautepec de Hinojosa, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N134/N134.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N133-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de pavimentación asfáltica de la C.E. Saucillo - Nopala (cuarta etapa), en el municipio de Nopala de Villagrán.; ubicada en la localidad y Municipio de Nopala de Villagrán, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N133/N133.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N132-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de concreto hidráulico de la calle Profesor Antonio Chávez Ibarra, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N132/N132.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N131-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Construcción de pavimentación hidráulica de camino Xilitla - Texopich, segunda etapa, en el municipio de Tepehuacán de Guerrero.; ubicada en la localidad de Acoyotla, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N131/N131.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N130-2026.',
        'vigencia' : '7 al 21 de septiembre de 2026.',
        'descripcionProcedimiento' : 'Ampliación de la lateral de servicios del Blvd. Luis D. Colosio, tramo: Blvd. Nuevo Hidalgo al Blvd. Felipe Ángeles, frente al Centro SICT Hidalgo, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligasipdus }40/N130/N130.rar`,
        'start' : '2026-09-07',
        'end' : '2026-09-21',
        'procedimiento' : 'Licitación Pública',
    },
]